/**
 * Application constants
 */

import { NetworkOption } from '@/types'

export const DEVICE_TAG_COOKIE_NAME = 'device_tag'
export const DEVICE_TAG_COOKIE_EXPIRY_DAYS = 365

export const MOBILE_NETWORKS: NetworkOption[] = [
  { value: 'MTN', label: 'MTN Mobile Money' },
  { value: 'TELECEL', label: 'Telecel Cash' },
  { value: 'AIRTELTIGO', label: 'AirtelTigo Money' },
]

export const MIN_AMOUNT = 0.01
export const MAX_AMOUNT = 100000

export const PHONE_REGEX = /^0[0-9]{9}$/

// In development, use relative URLs to leverage Vite proxy
// In production, use the full API URL from environment variable
export const API_BASE_URL =
  import.meta.env.MODE === 'development'
    ? '' // Use relative URLs in dev (Vite proxy handles it)
    : import.meta.env.VITE_API_BASE_URL || 'https://api.selenite.africa'

export const API_ENDPOINTS = {
  MERCHANT: (publicId: string) => `/api/client/business-portal/retrieve-merchant?public_id=${publicId}`,
  USER_DEVICE: (tag: string) => `/api/client/business-portal/qr-users/?tag=${tag}`,
  USER_DEVICE_CREATE: '/api/client/business-portal/qr-users/',
  USER_DEVICE_UPDATE: (id: number) => `/api/client/business-portal/qr-users/${id}`,
  PAYMENT_VALIDATE: '/api/client/business-portal/qr-users/validate',
  PAYMENT_PAY: '/api/client/business-portal/qr-users/pay',
  PAYMENT: '/api/payments/', // Legacy endpoint (keeping for backward compatibility)

  // WebAuthn endpoints for device persistence
  WEBAUTHN_REGISTER_OPTIONS: '/api/client/business-portal/webauthn/register/options',
  WEBAUTHN_REGISTER_COMPLETE: '/api/client/business-portal/webauthn/register/complete',
  WEBAUTHN_AUTH_OPTIONS: '/api/client/business-portal/webauthn/auth/options',
  WEBAUTHN_AUTH_COMPLETE: '/api/client/business-portal/webauthn/auth/complete',
} as const

